import React, { useEffect } from "react";
import "../PaymentDialogues/PaymentDialogue.scss";
import { PrimaryButton } from "../AllButtons/AllButtons";
import { Button, Dialog, DialogContent } from "@mui/material";
import CancelRound from "../../assets/images/vactor/cancel-payments.svg";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { cancelPaypalPayment } from "../../Services/payment.service";

const PaymentCancelled = () => {
  const [open, setOpen] = React.useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const redirect=useAppSelector(state=>state.paymentLoader.redirect);
  // Get the token from URL query parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      dispatch(cancelPaypalPayment(token))
        .unwrap();
    }
  }, [token, dispatch]);

  const handleClose = () => {
    setOpen(false);
    if(redirect){
    navigate("/dashboard");
    }
  };

  return (
    <div className="alert-dialog-wrapper">
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="alert-dialog"
        disableEscapeKeyDown
      >
        <DialogContent>
          <div className="upgrade-dialog-body">
            <div className="upgrade-icon">
              <img src={CancelRound} alt="Payment Cancelled" />
            </div>
            <div className="upgrade-dialog-title">Payment Cancelled!</div>
            <div className="upgrade-dialog-dsc">
              Your PayPal transaction was cancelled. You can try again to upgrade your plan and continue learning with YULI.
            </div>

            <div className="upgrade-action-btn">
              <PrimaryButton onClick={() => redirect && navigate('/price')}>
                Try Again
              </PrimaryButton>
              <Link to="#" className="link-btn"
               onClick={(e) => {
                e.preventDefault();//paymnt
                handleClose();
              }}
              >
                Back to Dashboard
              </Link>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PaymentCancelled;